import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

import { Tooltip } from '@components/ui/Tooltips'
import { Typography } from '@components/ui/Typography'

import { HelpFilledIcon, KeyboardArrowDownIcon, KeyboardArrowUpIcon } from '../svgIcons'

const IndexTypography = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 2px;

  & > span {
    display: inline-flex;
    align-items: inherit;

    &:last-child {
      font-size: 14px;
    }
  }
`

interface KPIIndexProps {
  value?: number | null
}

export function KPIIndex({ value }: KPIIndexProps) {
  if (value == null) {
    return (
      <Tooltip
        title={<FormattedMessage id="tooltips.kpi" defaultMessage="Nincs kiválaszott időszak" />}
        placement="bottom"
      >
        <IndexTypography color="gray-80" size="700-xs">
          <FormattedMessage tagName="span" id="kpi.notAvailable" defaultMessage="N/A" />
          <span>
            <HelpFilledIcon size={16} />
          </span>
        </IndexTypography>
      </Tooltip>
    )
  }

  return (
    <IndexTypography size="700-xs" color={value < 0 ? 'error' : 'success'}>
      <span>{value}%</span>
      <span>{value < 0 ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />}</span>
    </IndexTypography>
  )
}
